import React, { memo, useCallback } from 'react';
import styles from './ClassCard.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../../../actions/log';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { CONTEXT } from '../../../../config';
import Toast from '../../../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const handleCard = useCallback(
    (e, data, studyState) => {
      e.stopPropagation();
      // 该课程已下架
      if (data && data.status && data.status === 3) {
        Toast.error({
          content: '该课程已下架，请选择其它课程',
        });
        return;
      }
      // dispatch(
      // logging({
      //   category: 'C',
      //   action: 'Edu_Mine_Pay',
      //   label: '',
      //   param2: {
      //     source: logInfoData.source,
      //     source_p: logInfoData.source_p,
      //     source_pp: logInfoData.source_pp,
      //     courseid: data.courseId,
      //     age_period: localGetItem(education.EDUSTAGE),
      //     discountPrice: (data.discountPrice / 100).toFixed(2),
      //   },
      // }),
      // );
      // dispatch(
      //   logPostInfo({
      //     source_p: logInfoData.source,
      //     source_pp: logInfoData.source_p,
      //   }),
      // );

      history.push(
        `${CONTEXT}/edudetail?courseId=${data.courseId}&bizInfo=${data.bizInfo ||
          '{}'}&studyState=${studyState}`,
      );
    },
    [logInfoData],
  );
  return (
    <div className={styles.class_card}>
      <div className={styles.left_img}>
        <img src={props.imgUrl} />
      </div>
      <div className={styles.right_info}>
        <div className={styles.info}>
          <div className={styles.info_title}>{props.name}</div>
          <div className={styles.info_line}>
            <div className={styles.line_title}>订单号</div>
            <div className={styles.line_info}>{props.orderId}</div>
          </div>
          <div className={styles.info_line}>
            <div className={styles.line_title}>支付时间</div>
            <div className={styles.line_info}>{props.successTime}</div>
          </div>
          <div className={styles.info_line}>
            <div className={styles.line_title}>支付金额</div>
            <div className={styles.line_info}>{props.payAmount}</div>
          </div>
          <div className={styles.info_line}>
            <div className={styles.line_title}>支付方式</div>
            <div className={styles.line_info}>
              {props.payType === 'WX' ? '微信支付' : '支付宝支付'}
            </div>
          </div>
          <div className={styles.info_line}>
            <div className={styles.line_title}>订单状态</div>
            <div className={styles.line_info}>
              {props.orderStatus === 10 ? '支付成功' : '支付失败'}
            </div>
          </div>
        </div>
        <div className={styles.info_statue}>
          {(!props.status || props.status === '1') && (
            <div
              className={styles.btn}
              onClick={e => {
                handleCard(e, props, 1);
              }}
            >
              继续学习
            </div>
          )}
          {props.status === '2' && (
            <div
              className={styles.btn}
              onClick={e => {
                handleCard(e, props, 2);
              }}
            >
              重新学习
            </div>
          )}
          {props.status === '3' && <div className={styles.statue}>已下架</div>}
        </div>
      </div>
    </div>
  );
});
